import { render, staticRenderFns } from "./DropBoxSelect.vue?vue&type=template&id=5b52aa18&scoped=true&"
import script from "./DropBoxSelect.vue?vue&type=script&lang=js&"
export * from "./DropBoxSelect.vue?vue&type=script&lang=js&"
import style0 from "./DropBoxSelect.vue?vue&type=style&index=0&id=5b52aa18&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b52aa18",
  null
  
)

export default component.exports